import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { IntegrationActionContext } from '../../integrationsMarketplaceGridInstalled/types';

export const templateSaveIntegration = document.createElement('template');

templateSaveIntegration.innerHTML = `
   <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper" id="save-integration-wrapper">

    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class="content-wrapper" id="add-account">

      <div class="form-wrapper"></div>

      <div class="bottom-buttons">
        <gz-button id="create-button" type="full" disabled></gz-button>
        <gz-button id="done-button" type="full"></gz-button>
        <div class="flex-auto"></div>
        <gz-button color="secondary" type="outline" id="cancel-button" ></gz-button>
      </div>

    </div>
  </div>`;
